export const POSTHOG_UI_HOST = 'https://us.posthog.com';
export const POSTHOG_PROXY_PATH = '/_kx';
export const POSTHOG_API_ORIGIN = 'https://us.i.posthog.com';
export const POSTHOG_ASSETS_ORIGIN = 'https://us-assets.i.posthog.com';
